<ng-content>
  <span
    cdkOverlayOrigin
    (click)="onIconClick($event)"
    [ngClass]="{ disabled: disabled() }"
    class="icon icon-options-inverted"
  ></span>
</ng-content>

<app-overlay-general [(show)]="show" [trigger]="computedCdkOverlayOrigin()">
  <div class="options-overlay-white">
    @for (item of actions(); track $index) {
      <div [appTooltip]="item?.tooltip">
        <div
          (click)="toggleShow(); onOptionSelected(item)"
          [ngClass]="{ 'disabled text-navy-500': item?.disabled }"
          [class]="item.class"
          class="option"
        >
          <span>{{ item.label | titlecase }}</span>
        </div>
      </div>
    }
  </div>
</app-overlay-general>
